import React from 'react'
import { Menu, Icon } from 'antd'
import { NavLink, withRouter} from 'react-router-dom'

import menus from '_src/config/menu'

import { parseArr, getRoutes, filterMenu } from '_src/utils/tool'
import { findSupLink } from '../../init/tool'
import { switchMenu } from '../../../redux/action'
import './index.less'

const SubMenu = Menu.SubMenu


@withRouter
class NavLeft extends React.Component {
	

	state = {
	  currentKey: '',
	  defaultOpenKeys: [],
	  defaultSelectedKeys: [],
	  openKey: [],
	  SelectedKeys: []
	}
	componentWillMount () {
	  const { location: {pathname} } = this.props
	  this.setMenuKey(pathname)
	}

	componentDidMount () {
	  // do something	
	}
	
	componentWillReceiveProps (nextProp) {
	  const { location: {pathname} } = this.props
	  const nextPathname = nextProp.location.pathname
	  if (pathname !== nextPathname) {
	    this.setMenuKey(nextPathname)
	  }
	}
	
	// 获取所有的key
	getKeys = () => {
	  const menusKey = parseArr(getRoutes(filterMenu(menus)))
	  return menusKey.map(item=> {
		  return item.key
	  })
	}
	

	// 根据pathname设置men展开项
	setMenuKey (pathname) {
	  const keys = findSupLink(menus, pathname)
	    if (keys.length === 1) {
	      this.setState(()=>({
	        openKey: [],
	        SelectedKeys: keys || ['/home']
	      }))
	    } else if (keys.length>1) {
	      const openKey = keys.slice(0, -1)
	      const SelectedKeys = keys[keys.length-1]
	      this.setState((preState)=>{
			  // 当前openkey和之前openkey合并
	        // let newOpenKey = new Set([...openKey, ...preState.openKey])
	        // newOpenKey = [...newOpenKey]
	        return {
	          openKey,
	          // openKey: [...openKey],
	          SelectedKeys: [SelectedKeys]
	        }
	      })
	    }
	}
	// 菜单渲染
	renderMenu =(data, id = '')=>{
	  return data.map((item) =>{
	    // 非一级菜单
	    let Node = null
	    if (item.children) {
	      Node = (
	        <SubMenu title={<span><Icon type={item.icon} />{item.title}</span>} key={item.key}>
	          {this.renderMenu(item.children)}
	        </SubMenu>
	      )
	    }
	    // 一级菜单
	    else if (!item.children) {
	      Node = (
	        <Menu.Item title={item.title} key={item.key} id={item.key}>
	          <NavLink to={item.key}><Icon type={item.icon} />{item.title}</NavLink>
	        </Menu.Item>
	      )
	    }
	    return Node
	  })
	}
	homeHandleClick = () => {
		this.props.history.push('/home')
	  this.setState({ currentKey: '' })
	}
	onOpenChange (openKeys) {
	//   this.setMenuKey(openKeys)
	  // console.log(this.getKeys())
	  const latestOpenKey = openKeys.find(key => this.state.openKey.indexOf(key) === -1)
	  //   console.log(latestOpenKey)
	  this.setState({
	    openKey: latestOpenKey ? [latestOpenKey] : [],
	  })
	  //   if (this.getKeys().indexOf(latestOpenKey) === -1) {
	  // 	  console.log('this')
	  //     this.setState({ openKey: openKeys })
	  //   } else {
	    // this.setState({
	    //   openKey: latestOpenKey ? [latestOpenKey] : [],
	    // })
	  //   }

	// 原代码
	//   this.setState(()=>({
	//     openKey: openKeys
	//   }))
	}

	render () {
	  const { openKey, SelectedKeys} = this.state
	  return (
	    <div className="nav-left-inner">
	      <NavLink to="/home" onClick={this.homeHandleClick}>
	        <div className="logo">
	          <img src="/assets/logo.png" alt="" />
	        </div>
	      </NavLink>
	      <Menu
	        className="ant-menu-inner"
	        openKeys={openKey}
	        selectedKeys = {SelectedKeys}
	        // defaultOpenKeys={defaultOpenKeys}
	        // defaultSelectedKeys = {defaultSelectedKeys}
	        onOpenChange = {(openKeys)=>{ this.onOpenChange(openKeys) }}

	        mode="inline"
	        onClick={this.handleClick}
	        theme="light"
	      >
	        { this.renderMenu(filterMenu(menus)) }
	      </Menu>
	    </div>
	  )
	}

	
}
export default NavLeft